export const MALE = 'H'
export const FEMALE = 'M'


// WEBPACK FOOTER //
// ./src/constants/genders.js